module.exports = __webpack_public_path__ + "img/emitFacebeauty03.e36ae12f.png";